<template>
  <div>
    <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
      <!-- 自定义标题 -->
      <div slot="title" class="dialog-title">
        <span class="fs16">{{ type == "check" ? "Refund Check" : "Refund Review" }}</span>
        <span class="blue crp ml6" @click="viewDetail">
          (
          <i class="el-icon-tickets"></i>
          Refund Detail )
        </span>
      </div>

      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="130px">
        <el-form-item label="Status" prop="status">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">Rejected</el-radio>
            <el-radio :label="1">Pass</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            :rows="5"
            :autosize="{ minRows: 4 }"
            resize="none"
            placeholder="Remark"
            v-regexFilter="halfWidthRegex"
          ></el-input>
        </el-form-item>
        <el-form-item label="attachments" prop="attachmentUrls">
          <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </span>
    </el-dialog>

    <!-- 退款详情 - 弹窗 -->
    <refund-detail ref="refundDetail" :detail="detail" />
  </div>
</template>

<script>
import RefundDetail from "./RefundDetail";
import { mapActions } from "vuex";
export default {
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    RefundDetail,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        status: 1,
        remark: "",
        attachmentUrls: [],
      },
      type: "",
      dataRule: {
        status: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false, // 防止重复提交
    };
  },
  methods: {
    ...mapActions("applyment", ["doSaveProcedures", "doRefundCheck", "doRefundAudit", "initApplyment"]),
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      this.type = data;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          let httpRes = null;
          let dataFormCopy = this.dataForm;
          if (this.type == "check") {
            let applymentStatus = dataFormCopy.status ? "REFUND_APPLY_AGREED" : "REFUND_APPLY_DENY";
            httpRes = this.doRefundCheck({ applymentStatus: applymentStatus, remark: dataFormCopy.remark, attachmentUrls: dataFormCopy.attachmentUrls });
          } else {
            let applymentStatus = dataFormCopy.status ? "REFUND_APPLY_PASS" : "REFUND_APPLY_REJECT";
            httpRes = this.doRefundAudit({
              applymentStatus: applymentStatus,
              remark: dataFormCopy.remark,
              attachmentUrls: dataFormCopy.attachmentUrls,
              lastApplymentStatus: this.detail.applymentStatus,
            });
          }

          httpRes
            .then(async () => {
              // 更新申请单详情
              await this.initApplyment(this.detail.id);
              this.$message({
                message: "success",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
    // 查看详情
    viewDetail() {
      this.$refs.refundDetail.init();
    },
  },
};
</script>
